<div class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" >

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Consolidar evaluaciones</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR
            <div class="toolbar px-24 py-8">
                <span>Preiniciar Evaluacion</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-50" fxLayout="column" fxFlex>

              <div fxLayout="column">

                    <div fxLayout="column" style="max-width:600px; margin:50px;">

                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Tipo de ponderación</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.tipo" class="roleSelect">
                              <mat-option *ngFor="let tipo of tiposPonderacion" [value]="tipo">
                                  {{tipo}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Factor de ponderación</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.factorPonderacion" class="roleSelect" (selectionChange)="selectFactor()">
                              <mat-option *ngFor="let factor of factoresPonderacion" [value]="factor">
                                  {{factor.nombre}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-label >Estructura jerárquica / Nodo:</mat-label>
                        <span *ngIf="LOCAL_DATA.nodoEstructuraJerarquica!=null" fxFlex class="px-20">{{LOCAL_DATA.estructuraJerarquica?.nombre}} / {{LOCAL_DATA.nodoEstructuraJerarquica?.nombre}}</span>
                        <button  style="margin-left:20px;" mat-button mat-raised-button (click)="openDialog()">Seleccionar Nodo</button>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Responsable</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.responsable" class="roleSelect" >
                            <ng-container *ngFor="let usuario of LOCAL_DATA.nodoEstructuraJerarquica?.usuarios">
                              <mat-option *ngIf="esOwnersGroup(usuario)" [value]="usuario">
                                {{usuario.nombreCompleto}}
                              </mat-option>
                            </ng-container>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de Inicio</mat-label>
                        <input matInput [matDatepicker]="picker1" [(ngModel)]="LOCAL_DATA.fechaInicio" (dateChange)="getEvaluaciones()">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de Finalización</mat-label>
                        <input matInput [matDatepicker]="picker2" [(ngModel)]="LOCAL_DATA.fechaFin" (dateChange)="getEvaluaciones()">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                      </div>

                    </div>
                </div>
              </div>

                <div class="content-card" *ngIf="action != 'Delete'">

                  <div class="content" >

                      <mat-tab-group dynamicHeight>

                          <mat-tab label="Evaluaciones">

                              <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                                <div fxFlex fxLayout="row wrap">
                                  <mat-form-field  fxFlex>
                                    <mat-label>Evaluaciones</mat-label>
                                    <mat-select [(ngModel)]="LOCAL_DATA.evaluaciones" class="roleSelect" multiple (selectionChange)="addEvaluacion()">
                                      <ng-container *ngFor="let eval of evaluaciones">
                                        <mat-option *ngIf="eval.estado=='COMPLETADO' || eval.estado=='APROBADO' || eval.estado=='CERRADO'" [value]="eval">
                                          {{eval.nombre}} <span style="color: blue;"> Versión {{eval.version}}</span> 
                                        </mat-option>
                                      </ng-container>
                                    </mat-select>
                                  </mat-form-field>
                                  <!--
                                  <button mat-raised-button color="accent" class="submit-button" aria-label="Agregar"
                                           (click)="addEvaluacion(evaluacionSelect)" [disabled]="evaluacionSelect==null">
                                      Agregar
                                  </button>-->
                                </div>

                                <!-- CONTENT -->
                                <div class="content p-24" fxLayout="row wrap">

                                    <table mat-table [dataSource]="LOCAL_DATA.evaluaciones" #mytable class="my-table mat-elevation-z8" fxFlex="100">

                                      <!--- Note that these columns can be defined in any order.
                                          The actual rendered columns are set as a property on the row definition" -->

                                          <ng-container matColumnDef="nombre">
                                            <th mat-header-cell *matHeaderCellDef> Nombre </th>
                                            <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="version">
                                            <th mat-header-cell *matHeaderCellDef> Versión </th>
                                            <td mat-cell *matCellDef="let element"> {{element.version}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="escenario">
                                            <th mat-header-cell *matHeaderCellDef> Escenario </th>
                                            <td mat-cell *matCellDef="let element"> {{element.escenario?.nombre}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="estructuraJerarquica">
                                            <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
                                            <td mat-cell *matCellDef="let element"> {{element.estructuraJerarquica?.nombre}} </td>
                                          </ng-container>


                                          <ng-container matColumnDef="creador">
                                            <th mat-header-cell *matHeaderCellDef> Creador </th>
                                            <td mat-cell *matCellDef="let element"> {{element.creador?.nombreCompleto}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="dueno">
                                            <th mat-header-cell *matHeaderCellDef> Dueño </th>
                                            <td mat-cell *matCellDef="let element"> {{element.owner?.nombreCompleto}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="fechaInicio">
                                            <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
                                            <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="fechaFin">
                                            <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
                                            <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="estado">
                                            <th mat-header-cell *matHeaderCellDef> Estado </th>
                                            <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
                                          </ng-container>

                                      <!-- Action Column -->
                                      <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef> Acción </th>
                                        <td mat-cell *matCellDef="let element" class="action-link">
                                          <a (click)="removeEvaluacion(element)">Eliminar</a>
                                        </td>
                                      </ng-container>

                                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>

                                </div>
                                <!-- / CONTENT -->
                              </div>
                          </mat-tab>

                          <mat-tab label="Escenario">

                              <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                                <!-- CONTENT -->
                                <div class="content p-24" fxFlex="100">

                                  <div fxFlex >
                                    <mat-form-field  fxFlex>
                                      <mat-label>Escenario</mat-label>
                                      <mat-select [(ngModel)]="LOCAL_DATA.escenario" class="roleSelect">
                                          <mat-option *ngFor="let escenario of escenarios" [value]="escenario">
                                              {{escenario.nombre}}
                                          </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <!--
                                <div class="content p-24">
                                  <mat-form-field class="select-edit px-10">
                                    <input placeholder="Formula de exposición ej: (P*0.4)+(I*0.6)" matInput [(ngModel)]="LOCAL_DATA.formulaDeExposicion" (ngModelChange)="formulaModificada()"
                                    onkeypress="return (event.charCode >= 40 && event.charCode <= 57 && event.charCode != 44) || event.charCode == 73 || event.charCode == 80 "
                                    [disabled]="action == 'View'">
                                  </mat-form-field>
                                  <mat-form-field class="select-edit-number px-10">
                                    <input placeholder="Apetito" matInput [(ngModel)]="LOCAL_DATA.apetito" type="number" value="" step="any" >
                                  </mat-form-field>
                                  <mat-form-field  class="select-edit-number px-10">
                                    <input placeholder="Tolerancia" matInput [(ngModel)]="LOCAL_DATA.tolerancia" type="number" value="" step="any" >
                                  </mat-form-field>

                                </div>
                                <!-- / CONTENT -->
                              </div>
                          </mat-tab>

                          <mat-tab label="Ponderación Evaluaciones" *ngIf="LOCAL_DATA.tipo=='EVALUACION'">

                              <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>
                                <!--
                                <div fxFlex fxLayout="row wrap">
                                  <mat-form-field  fxFlex>
                                    <mat-label>Factor</mat-label>
                                    <mat-select [(ngModel)]="ponderacionSelect" class="roleSelect" >
                                        <mat-option *ngFor="let ponderacion of ponderaciones" [value]="ponderacion">
                                            {{ponderacion.descripcion}} - {{ponderacion.porcentaje}}
                                        </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>-->

                                <!-- CONTENT -->
                                <div class="content p-24" fxFlex="100">

                                    <table mat-table [dataSource]="LOCAL_DATA.ponderacionesPorEvaluacion" #mytable class="my-table mat-elevation-z8" fxFlex="100">

                                      <!--- Note that these columns can be defined in any order.
                                          The actual rendered columns are set as a property on the row definition" -->

                                          <ng-container matColumnDef="evaluacion">
                                            <th mat-header-cell *matHeaderCellDef> Evaluación </th>
                                            <td mat-cell *matCellDef="let element"> {{element.evaluacion.nombre}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="factorPonderacion">
                                            <th mat-header-cell *matHeaderCellDef> Factor de ponderación </th>
                                            <td mat-cell *matCellDef="let element"> {{LOCAL_DATA.factorPonderacion.nombre}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="factor">
                                            <th mat-header-cell *matHeaderCellDef> Factor </th>
                                            <td mat-cell *matCellDef="let element">
                                              <mat-form-field fxFlex="80" >
                                                <mat-label>Factor</mat-label>
                                                <mat-select

                                                [(ngModel)]="element.factor" class="roleSelect" (selectionChange)="validarPonderacionesPorEvaluacion()">
                                                    <mat-option *ngFor="let ponderacion of ponderaciones" [value]="ponderacion">
                                                      {{ponderacion.factor}} - {{ponderacion.descripcion}}
                                                    </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </td>
                                            <!--<td mat-cell *matCellDef="let element"> {{element.factor?.descripcion}} - {{element.factor?.porcentaje}} </td>-->
                                          </ng-container>


                                      <tr mat-header-row *matHeaderRowDef="displayedColumnsPonderaciones"></tr>
                                      <tr mat-row *matRowDef="let row; columns: displayedColumnsPonderaciones;"></tr>
                                    </table>

                                </div>
                              </div>
                          </mat-tab>

                          <mat-tab label="Ponderación por objetivos" *ngIf="LOCAL_DATA.tipo=='OBJETIVO'">

                              <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                                <!-- CONTENT -->
                                <div class="content p-24" fxFlex="100" >

                                    <table mat-table [dataSource]="LOCAL_DATA.ponderacionesPorObjetivo" #mytable class="my-table mat-elevation-z8" fxFlex="100">

                                      <!--- Note that these columns can be defined in any order.
                                          The actual rendered columns are set as a property on the row definition" -->

                                          <ng-container matColumnDef="evaluaciones">
                                            <th mat-header-cell *matHeaderCellDef> Evaluaciones. </th>
                                            <td mat-cell *matCellDef="let element">
                                              <mat-chip-list aria-label="Evaluaciones">
                                                <mat-chip *ngFor="let evaluacion of element.evaluaciones">{{evaluacion.nombre}}</mat-chip>
                                              </mat-chip-list>
                                            </td>
                                          </ng-container>

                                          <ng-container matColumnDef="objetivo">
                                            <th mat-header-cell *matHeaderCellDef> Objetivo </th>
                                            <td mat-cell *matCellDef="let element"> {{element.objetivo.nombre}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="factor">
                                            <th mat-header-cell *matHeaderCellDef> Factor </th>
                                            <td mat-cell *matCellDef="let element">
                                              <mat-form-field fxFlex="80" >
                                                <mat-label>Factor</mat-label>
                                                <mat-select

                                                [(ngModel)]="element.factor" class="roleSelect" (selectionChange)="validarPonderacionesPorObjetivo()">
                                                    <mat-option *ngFor="let ponderacion of ponderaciones" [value]="ponderacion">
                                                        {{ponderacion.factor}} - {{ponderacion.descripcion}}
                                                    </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </td>
                                          </ng-container>


                                      <tr mat-header-row *matHeaderRowDef="displayedColumnsPonderacionesObjetivos"></tr>
                                      <tr mat-row *matRowDef="let row; columns: displayedColumnsPonderacionesObjetivos;"></tr>
                                    </table>

                                </div>
                              </div>
                          </mat-tab>

                        </mat-tab-group>
                    </div>

                </div>
                <div fxFlex class="px-24 py-8">

                  <button mat-raised-button color="accent" class="submit-button mx-12 my-12" aria-label="Crear"
                           (click)="addConsolidacion()" [disabled]="LOCAL_DATA.responsable==null || LOCAL_DATA.factorPonderacion==null ||
                           LOCAL_DATA.nodoEstructuraJerarquica==null || LOCAL_DATA.nombre=='' || LOCAL_DATA.tipo==null ||
                           LOCAL_DATA.escenario==null ||
                           LOCAL_DATA.evaluaciones.length ==0 || factoresIncompletos">
                      Guardar
                  </button>
                  
                  <button mat-button mat-flat-button color="warn"
                           (click)="navegateTo('/mis-evaluaciones-consolidadas','')" class="mx-12 my-12">
                      Cancelar
                  </button>



                </div>


            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
